import { useState as f, useEffect as a } from "react";
import { _ as d } from "./chunks/index-CpGuKBKg.js";
import u from "./socket.js";
const E = (r) => {
  const e = u.get(r), [t, c] = f(e.connected);
  return a(() => {
    const n = () => c(e.connected), o = (s) => {
      const i = s.message.includes("Authentication") ? "We were unable to authorize your socket connection, please try logging in again." : s.message;
      d.error(i), c(!1);
    };
    return e.on("connect", n), e.on("connect_error", o), e.on("disconnect", n), () => {
      e.off("connect", n), e.off("connect_error", o), e.off("disconnect", n);
    };
  }, []), { connect: ({ token: n }) => {
    t || (e.auth = { token: n }, e.connect());
  }, disconnect: () => {
    t && e.disconnect();
  }, emit: (n, o) => e.emit(n, o), isConnected: t, off: (n, o) => e.off(n, o), on: (n, o) => {
    if (!n.includes("connect")) return e.on(n, o);
    console.error(
      "You are not permitted to add `connect` or `disconnect` event listeners to sockets provided by `useSocket`. Either edit the global listeners in the `useSocket` hook, or listen for changes on `socket.isConnected` in a `useEffect`."
    );
  } };
};
export {
  E as default
};
